import React from "react";
import { Navigate, Route } from "react-router-dom";

import AuthLayout from "@/features/auth-layout";
import PasswordResetConfirm from "@/features/auth-login/components/password-reset-confirm";
import ExternalLoginForm from "@/features/external-login/components/external-login-form";

interface AuthRoutesProps {
  isLoggedIn: boolean;
  search: string;
}

export const renderAuthRoutes = ({ isLoggedIn, search }: AuthRoutesProps) => (
  <Route element={<AuthLayout />}>
    {/* If already logged in, redirect home. */}
    {isLoggedIn && (
      <Route path="/login" element={<Navigate to="/" replace />} />
    )}

    <Route path="/login" element={<Navigate to="/" replace />} />
    <Route path="/signup" element={<Navigate to="/" replace />} />
    <Route
      path="/reset-password"
      element={<Navigate to="/?action=reset-password" replace />}
    />
    <Route path="/verify" element={<Navigate to="/" replace />} />

    <Route path="/login/external" element={<ExternalLoginForm />} />

    {/* Only used for Live TV password resetting */}
    <Route path="/edit-password" element={<PasswordResetConfirm />} />

    <Route
      path="/auth/password/new"
      element={<Navigate to="/reset-password" replace />}
    />
    <Route
      path="/auth/password/edit"
      element={<Navigate to={`/edit-password${search}`} replace />}
    />
    <Route
      path="/tv-auth/password/edit"
      element={<Navigate to={`/edit-password${search}`} replace />}
    />
  </Route>
);
